// extracted by mini-css-extract-plugin
export default {"statusChip":"StatusChip_statusChip__Txnfy","green":"StatusChip_green__Gz-bI","red":"StatusChip_red__SAIaZ","yellow":"StatusChip_yellow__SGokz","blue":"StatusChip_blue__JNkFK"};